import React, { useState } from "react";

import { motion } from "framer-motion";
import MyLoader from "../MyLoader";
import TextField from "../../UI/textField";
import TextArea from "../../UI/textArea";
import Button from "../../UI/button";
import { ShowSuccess, ShowError } from "../toast/toast-function";
const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    organization: "",
    about: "",
  });
  const [loader, setLoader] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const CreateRequestHandler = () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      organisation: formData.organization,
      description: formData.about,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `https://api.dev.theflexmanager.com/api/contact/createNewQueryRequest`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          ShowSuccess(
            "Your request has been submitted successfully. A representative will contact you shortly."
          );
          setLoader(false);
          setFormData({
            ...formData,
            fullName: "",
            email: "",
            phone: "",
            organization: "",
            about: "",
          });
        } else {
          setLoader(false);
          ShowError("Oops! something went wrong.")
        }
      })
      .catch((error) => console.error(error));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Email validation pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (formData.fullName.trim() === "") {
      ShowError("Full name is required.");
    } else if (formData.phone.trim() === "") {
      ShowError("Phone number is required.");
    } else if (formData.email.trim() === "") {
      ShowError("Email is required.");
    } else if (!emailRegex.test(formData.email.trim())) {
      ShowError("Please enter a valid email.");
    } else if (formData.organization.trim() === "") {
      ShowError("Organization is required.");
    } else if (formData.about.trim() === "") {
      ShowError("Description is required.");
    } else {
      CreateRequestHandler();
    }
  };
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };
  return (
    <div className="mb-10">
      <div className="w-[90%] lg:w-[40%] mx-auto bg-white shadow-xl pb-16 border-b-[5px] border-btnColor rounded-md">
        <div className="w-[90%] mx-auto">
          <form onSubmit={handleSubmit}>
            <motion.div className="rounded-md mt-2" variants={itemVariants}>
              <TextField
                id="fullName"
                name="fullName"
                label="Name"
                value={formData.fullName}
                onChange={handleChange}
                fullWidth
              />
            </motion.div>

            {/* Email field */}
            <motion.div variants={itemVariants} className="mt-4">
              <TextField
                id="email"
                name="email"
                label="Email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
              />
            </motion.div>

            {/* Job Title field */}
            <motion.div variants={itemVariants} className="mt-4">
              <TextField
                id="phone"
                name="phone"
                label="Phone"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
              />
            </motion.div>
            <motion.div variants={itemVariants} className="mt-4">
              <TextField
                id="organization"
                name="organization"
                label="Organization"
                value={formData.organization}
                onChange={handleChange}
                fullWidth
              />
            </motion.div>

            {/* How Can we Help You? field */}
            <motion.div className="mt-4 relative" variants={itemVariants}>
              <TextArea
                id="about"
                name="about"
                label="Description"
                value={formData.about}
                onChange={handleChange}
                rows={5}
                fullWidth
              />
            </motion.div>

            {/* Submit button */}
            <motion.div
              className="mt-4 flex justify-center "
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {loader ? (
                <div>
                  <MyLoader />
                </div>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleSubmit}
                >
                  Send
                </Button>
              )}
            </motion.div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
